// src/helpers/transfers.js
import { doc, getDoc } from "firebase/firestore";
// import app from "../firebase";
import {db as firestore} from "../firebase"

// Pricing
export const TRANSFER_BASE = 19.95;
export const TRANSFER_EXTRA = 0.2;

export const priceForCount = (n) =>
  Number((TRANSFER_BASE + Math.max(0, n - 1) * TRANSFER_EXTRA).toFixed(2));

export const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || "").trim());

/**
 * Reads users/{uid}.freeListingUntil and decides whether to skip payment.
 * Returns { skip: boolean, reason: 'coupon' | 'no-coupon' | 'error' }
 */
export async function shouldSkipPayment(uid) {
  try {
    if (!uid) return { skip: false, reason: "error" };
    const ref = doc(firestore, "users", uid);
    const snap = await getDoc(ref);
    const data = snap.exists() ? snap.data() : {};
    const now = Date.now();

    const until =
      typeof data?.freeListingUntil === "number"
        ? data.freeListingUntil
        : data?.freeListingUntil?.toMillis
        ? data.freeListingUntil.toMillis()
        : 0;

    if (until > now) return { skip: true, reason: "coupon" };
    return { skip: false, reason: "no-coupon" };
  } catch {
    // Fail-safe: do NOT skip payment if we can't verify
    return { skip: false, reason: "error" };
  }
}
